// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","marketingMaterial":"_1OKVLzmW4hpQK_vBnMYi1o"};